// Supported languages from i18n.ts
import {DropdownOptionProps} from '../../../models/DropdownProps';
import {countryResource} from './CountryResource';
import {languageResource} from './LanguageResource';
import {SELECT_COUNTRY, SELECT_LANGUAGE} from '../../../utils/DropdownOptionPropsUtils';

const supportedLanguages = languageResource.filter(language => SELECT_LANGUAGE !== language.value).map(language => language.value);
const supportedCountries = countryResource.filter(country => SELECT_COUNTRY !== country.value).map(country => country.value);

export const countryLanguageResource: DropdownOptionProps[] = supportedCountries.flatMap(country =>
    supportedLanguages.map(language => ({name: language, value: country} as DropdownOptionProps))
);
